import { render, staticRenderFns } from "./registerUse.vue?vue&type=template&id=14488d4f&scoped=true"
import script from "./registerUse.vue?vue&type=script&lang=js"
export * from "./registerUse.vue?vue&type=script&lang=js"
import style0 from "./registerUse.vue?vue&type=style&index=0&id=14488d4f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14488d4f",
  null
  
)

export default component.exports